<template>
	<v-row dense>
		<template v-for="(optionVals, optionKey) in contents[contentKey].inputItems[inputItemKey].options">
			<v-col :key="optionKey" cols="auto">
				<validation-provider
						:name="'AdminCheckbox-' + contentKey + '-' + inputItemKey"
						:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
						mode="lazy"
						v-slot="{ errors }">
					<v-checkbox
							v-model="$store.state.admin.input[inputItemKey]"
							multiple
							:value="optionKey"
							:label="optionVals.title"
							:error-messages="errors" />
				</validation-provider>
			</v-col>
		</template>
	</v-row>
</template>

<script>
	export default {
		name: 'AdminCheckbox',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		}
	}
</script>

<style scoped>
</style>
